import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { DirtyFormService } from '@app/services/dirty-form.service';
import { SistemaDatosService } from '@app/core/services/sistema-datos.service';
import { SystemSettingsService } from '@app/core/services/system-settings.service';
import { LayoutService } from '@app/layout/service/layout.service';

@Component({
    selector: 'app-global-header',
    templateUrl: './global-header.component.html',
    styleUrls: ['./global-header.component.scss'],
    standalone: false
})
export class GlobalHeaderComponent implements OnInit {
    @Input() items: MenuItem[] = [];
    @Input() titulo: string = 'Título por defecto';
    @Input() subtitulo?: string | null;

    // Opcional: mostrar/ocultar botón global de volver
    @Input() showBackButton: boolean = true;
    // Ruta de fallback si no hay historial para volver
    @Input() backFallback: string | any[] = '/';
    // Texto del botón (por defecto "Volver")
    @Input() backLabel: string = 'Volver';
    // Permite desactivar la confirmación por cambios sin guardar en vistas que ya usan un guard propio
    @Input() confirmDirtyOnBack: boolean = true;

    constructor(
        private location: Location,
        private router: Router,
        private confirmationService: ConfirmationService,
        private dirtySvc: DirtyFormService,
        private sistemaSvc: SistemaDatosService,
        private settingsSvc: SystemSettingsService,
        public layoutService: LayoutService,
        private cdRef: ChangeDetectorRef
    ) {}

    // Logos de encabezado (claro/oscuro) obtenidos desde BD y/o settings
    private sdHeaderLight?: string;
    private sdHeaderDark?: string;
    private cacheBuster?: string;

    ngOnInit(): void {
        // Cargar branding desde BD (fuente de verdad)
        this.sistemaSvc.get().subscribe({
            next: (d) => {
                if (d) {
                    this.sdHeaderLight = d.logo_global_header || undefined;
                    this.sdHeaderDark = d.logo_global_header_dark || undefined;
                    this.cacheBuster = String(Date.now());
                    this.cdRef.markForCheck();
                }
            },
            error: () => {}
        });

        // Fallback desde settings locales de "administracion-blister"
        try {
            const raw = localStorage.getItem('system_settings_administracion-blister');
            if (raw) {
                const obj = JSON.parse(raw);
                this.sdHeaderLight = this.sdHeaderLight || obj.brandLogoUrlLight || obj.brandLogoUrl || this.sdHeaderLight;
                this.sdHeaderDark = this.sdHeaderDark || obj.brandLogoUrlDark || obj.brandLogoUrlLight || this.sdHeaderDark;
            }
        } catch {}
    }

    private withV(url?: string): string | undefined {
        if (!url) return undefined;
        if (url.startsWith('assets/') || url.startsWith('data:')) return url; // no versionamos assets locales ni data URLs
        const v = this.cacheBuster || '1';
        return url.includes('?') ? `${url}&v=${v}` : `${url}?v=${v}`;
    }

    get headerLogoUrl(): string | undefined {
        const isDark = !!this.layoutService.isDarkTheme();
        // Fallback de settings para compatibilidad (tipos flexibles)
        const settings: any = this.settingsSvc.get('administracion-blister' as any);
        const light = this.sdHeaderLight || settings.brandLogoUrlLight || settings.brandLogoUrl || 'assets/images/icons/logo_original_200w.png';
        const dark = this.sdHeaderDark || settings.brandLogoUrlDark || settings.brandLogoUrlLight || 'assets/images/icons/logo_original_200w.png';
        const chosen = isDark ? dark : light;
        return this.withV(chosen) || chosen;
    }

    private navigateBackOrFallback(): void {
        if (history.length > 1) {
            this.location.back();
        } else {
            if (Array.isArray(this.backFallback)) {
                this.router.navigate(this.backFallback as any[]);
            } else {
                this.router.navigateByUrl(this.backFallback as string);
            }
        }
    }

    onBack(): void {
        if (this.confirmDirtyOnBack && this.dirtySvc.isDirty()) {
            this.confirmationService.confirm({
                message: '¿Querés volver? Perderás los datos ingresados que aún no guardaste.',
                header: 'Datos sin guardar',
                icon: 'pi pi-exclamation-triangle text-yellow-500',
                acceptLabel: 'Salir',
                rejectLabel: 'Cancelar',
                acceptButtonStyleClass: 'p-button-danger',
                rejectButtonStyleClass: 'p-button-text',
                accept: () => {
                    // Evitar doble diálogo con posibles guards: limpiamos la marca local
                    this.dirtySvc.reset();
                    this.navigateBackOrFallback();
                },
                reject: () => {}
            });
            return;
        }

        this.navigateBackOrFallback();
    }

    // En los componentes donde se quiera usar este encabezado, debo tener este codigo completado con los respectivos datos:
    // ----------------------------------------------------------------------------------------------------------------------------------

    // En esta linea ponemos los menús para navegar, depende el caso, pero generalmente es la casita (home) / Página principal del modulo / (Add-Historico-Parametros-etc)

    // breadcrumbItems: MenuItem[] = [{ label: '', icon: 'pi pi-home', routerLink: '/' }, { label: 'Gestión Vehicular', routerLink: '/gestionvehicular/home' }, { label: 'Agregar' }];

    // ----------------------------------------------------------------------------------------------------------------------------------
}
